import "react-quill/dist/quill.snow.css";
import ReactQuill from "react-quill";
import { Card, CardContent } from "./ui/card";
import { cn } from "../lib/utils";

function Editor({ value, setValue }) {
  const modules = {
    toolbar: [
      [{ font: [] }, { size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      // [{ script: "sub" }, { script: "super" }],
      [{ header: [1, 2, 3, false] }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      // ["link", "image", "blockquote", "code-block"],
      ["link", "blockquote"],
      ["clean"],
    ],
  };

  return (
    <Card className="max-w-full border-none">
      <CardContent className="p-0 border-none">
        <div className={cn("rounded-md border-none")}>
          <ReactQuill
            theme="snow"
            value={value || ""}
            onChange={(content, delta, source, editor) => {
              setValue(content);
            }}
            modules={modules}
            className={cn(
              "min-h-full",
              "[&_.ql-toolbar]:rounded-t-md [&_.ql-container]:rounded-b-md",
              "[&_.ql-toolbar]:border-b [&_.ql-toolbar]:bg-webPrimary [&_.ql-toolbar]:text-white",
              "[&_.ql-container]:border-0 [&_.ql-container]:bg-background [&_.ql-editor]:p-4 [&_.ql-editor]:text-sm"
            )}
          />
        </div>
      </CardContent>
    </Card>
  );
}

export default Editor;
